import React from "react";
import { Card, Form, Checkbox, Divider, Button, InputNumber, Col, Row, Modal, Input, message, Radio, Upload, Spin, Icon, DatePicker, Tooltip } from 'antd';
// import TitleTop from '@pages/Assembly/titleTop';
import NHFetch from "../../../utils/NHFetch";
// import NHSelect from "../../common/NHSelect";
import NHFormItem from '../../common/NHFormItem';
import { getLoginUser, createUuid } from "../../../utils/NHCore";
import PropTypes from 'prop-types';
import { NHModal, NHConfirm } from '../../common/NHModal';
// import Item from "_antd@3.26.20@antd/lib/list/Item";
// const Dragger = Upload.Dragger;
// const FormItem = Form.Item;
// const CheckboxGroup = Checkbox.Group;
// const { TextArea } = Input;
const basicUrl = "/yxxc/";
const hjdm = "GD001_4";   //环节代码
// const jfxtBasicUrl = 'api/zhxg-jfxt/';

/**
 * 绿色通道
 * Author: zengxiangkai@ly-sky.com
 * Created on: 2018-06-26
 * Version: 1.0
 * Modify log:
 */
class Lstd extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            editable: true,
            hjblztData: {}, //环节办理状态信息
            DkgzData: [],//抵扣项目数据
            studentData: {},
            loading: false,
            hjxxmxData: [],//缓交明细数据信息
        }
    }

    //渲染前获取 绿色通道办理原因
    componentDidMount() {

    }



    componentWillReceiveProps(nextProps) {

        if ('studentData' in nextProps) {
            const studentData = nextProps.studentData;

            //查询到学生信息时才显示绿色通道环节办理业务项
            if (Object.keys(studentData).length !== 0) {
                //查询到不同学生，查找该学生应缴费用
                if (JSON.stringify(this.state.studentData) === '{}' || this.state.studentData !== studentData) {
                    this.setState({ studentData: studentData });
                    // this.getLstdYjjeData(studentData);
                    this.getDkgzData(studentData)
                    this.getHjxxmxData(studentData)
                    // this.getLstdData();
                }

            }
        }

        if ('hjblztData' in nextProps) {
            const hjblztData = nextProps.hjblztData;
            const lstdData = this.state.lstdData;

            if (hjblztData) {
                this.setState({ hjblztData: hjblztData });
            } else {
                this.setState({ hjblztData: hjblztData });
            }
        }

    }





    //读取抵扣项目信息 */
    getDkgzData = () => {
        const { xsid } = this.props.studentData;
        if (xsid) {
            NHFetch('/yntzy/yxxc/lstd/queryDkgz', 'GET', { xsid: xsid }).then(resData => {
                if (resData && resData.data) {
                    this.setState({ DkgzData: resData.data, editable: true, })
                } else if (resData.data == null) {
                    this.setState({ DkgzData: [], editable: true });

                }
            }).catch((ress) => {
                this.setState({ DkgzData: [], });
            });
        } else {
            message.error("学生信息获取失败，请联系管理员")
        }
    }

    //读取学生缓交明细信息 */
    getHjxxmxData = () => {
        const { xsid } = this.props.studentData;
        if (xsid) {
            NHFetch('/yntzy/yxxc/lstd/queryHjxxmx', 'GET', { xsid: xsid }).then(resData => {
                if (resData && resData.data.length > 0) {
                    this.setState({ hjxxmxData: resData.data, editable: false, })
                } else if (resData.data == null) {
                    this.setState({ hjxxmxData: [], editable: true });

                }
            }).catch((ress) => {
                this.setState({ hjxxmxData: [], editable: true });
            });
        } else {
            message.error("学生信息获取失败，请联系管理员")
        }
    }


    //取消办理
    handleCancel = () => {
        const { pkid } = this.state.hjblztData;
        const { xsid } = this.state.studentData;
        let userId = getLoginUser() ? getLoginUser().userId : '';
        let params = { xsid: xsid, hjdm: hjdm, yhbh: userId, lchjid: pkid };
        NHConfirm("是否确定取消办理？", () => {
            this.setState({ loading: true })
            NHFetch('/yntzy/yxxc/lstd/deleteHjxxAndHjxxmx', 'POST', { xsid: xsid }).then(res => {
                if (res) {
                    if (res.data == '1') {
                        NHFetch(basicUrl + 'cancelCustomLinkData', 'POST', params)
                            .then(res => {
                                if (res) {
                                    if (res.data == '1') {
                                        this.setState({ loading: false, editable: true })
                                        message.success('环节办理取消成功！');
                                        //取消办理完成回调
                                        //this.getLstdData(this.state.studentData);
                                        const onFinish = this.props.onFinish;
                                        if (onFinish) {
                                            onFinish('cancel');
                                        }
                                    } else {
                                        this.setState({ loading: false })
                                        message.error('环节办理取消失败，请重试！');
                                    }
                                }
                            })
                    } else {
                        this.setState({ loading: false })
                        message.error('删除数据错误，请联系管理员');
                    }
                }
            })
        }, "warn");
    }

    //打印报到单回调
    handlePrint = () => {
        let onPrint = this.props.onPrint;
        if (onPrint) {
            onPrint();
        }
    }

    //上一步
    handleLast = () => {
        let onLast = this.props.onLast;
        if (onLast) {
            onLast();
        }
    }

    //下一步
    handleNext = () => {
        let onNext = this.props.onNext;
        if (onNext) {
            onNext();
        }
    }




    // 提交办理
    handleSubmit = e => {
        const { xsid } = this.props.studentData;
        const { pkid } = this.state.hjblztData;
        let userId = getLoginUser() ? getLoginUser().userId : '';
        this.setState({ loading: true });
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (err) {
                this.setState({ loading: false });
                return false;
            }
            console.log(values)
            NHFetch('/yntzy/yxxc/lstd/insertHjxxAndHjmx', 'POST', { formData: values, xsid: xsid, yhbh: userId, }).then(res1 => {
                if (res1) {
                    if (res1.data == '1') {
                        let params = { xsid: xsid, lchjid: pkid, formData: null, yhbh: userId, hjdm: hjdm };
                        NHFetch(basicUrl + 'saveCustomLinkData', 'POST', params)
                            .then(res => {
                                if (res) {
                                    if (res.data == '1') {
                                        this.setState({ loading: false, editable: false })
                                        message.success('环节办理成功！');
                                        this.getHjxxmxData();
                                        //办理完成回调
                                        const onFinish = this.props.onFinish;
                                        if (onFinish) {
                                            onFinish('submit');
                                        }
                                    } else {
                                        this.setState({ loading: false })
                                        message.error('环节办理失败，请重试！');
                                    }
                                }
                                this.setState({ loading: false })
                            })
                    } else {
                        this.setState({ loading: false })
                        message.error('缓交数据保存失败，请重试！');
                    }
                }
                this.setState({ loading: false })
            }
            )
        });
    };






    render() {
        const { form, lchjData = {}, hasLast, hasNext } = this.props;
        const { editable, loading, DkgzData, hjxxmxData } = this.state;
        console.log(DkgzData)
        console.log(editable)
        console.log(hjxxmxData)
        const { sfdybdd = '0' } = lchjData; //是否打印报到单

        const formItemLayout = { //表单项布局
            labelCol: {
                xs: { span: 24 },
                sm: { span: 12 },
                md: { span: 10 },
                lg: { span: 4 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 12 },
                md: { span: 10 },
                lg: { span: 16 },
            }
        }
        const { getFieldDecorator } = this.props.form;
        return (
            <div>
                <Card type="inner" title="绿色通道业务信息">
                    {editable ?
                        <Form>{
                            DkgzData.map((item, index) => {
                                return (
                                    <NHFormItem id={item.itemId} label={item.itemName + '(最多缓交金额为：' + item.itemCost + ')'} form={form} required={false}
                                        formItemLayout={formItemLayout}>
                                        <InputNumber
                                            style={{ width: '50%' }}
                                            formatter={value => `￥ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            parser={value => value.replace(/\￥\s?|(,*)/g, '')}
                                            precision={2}
                                            max={item.itemCost}
                                            min={0}

                                        />
                                    </NHFormItem>)
                            })}
                        </Form> :
                        <Form>{
                            hjxxmxData.map((item, index) => {
                                return (
                                    <NHFormItem id={item.SFXMMC} label={item.SFXMMC} form={form} required={false}
                                        formItemLayout={formItemLayout}
                                        initialValue={item.HJJE}
                                    >
                                        <InputNumber
                                            style={{ width: '50%' }}
                                            disabled={true}
                                            formatter={value => `￥ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            parser={value => value.replace(/\￥\s?|(,*)/g, '')}
                                            precision={2}
                                        />
                                    </NHFormItem>)
                            })
                        }
                        </Form>
                    }
                </Card>
                <Divider style={{ margin: '40px 0 24px' }} />
                {
                    editable ?
                        <Button type="primary" onClick={this.handleSubmit} loading={loading}>确认办理</Button>
                        : <Button type="primary" onClick={this.handleCancel} loading={loading}>取消办理</Button>
                }
                {
                    sfdybdd == '1' ? <Button type="primary" loading={this.props.loading} ghost style={{ marginLeft: 10 }} onClick={this.handlePrint}>打印报到单</Button> : null
                }
                {
                    hasLast ? <Button type="primary" ghost style={{ marginLeft: 10 }} onClick={this.handleLast}>上一步</Button> : null
                }
                {
                    hasNext ? <Button type="primary" ghost style={{ marginLeft: 10 }} onClick={this.handleNext}>下一步</Button> : null
                }
            </div>
        )
    }
}

Lstd.propTypes = {
    studentData: PropTypes.object, //学生信息
    hjblztData: PropTypes.object, //环节办理状态信息
    lchjData: PropTypes.object, //流程环节信息数据
    hasLast: PropTypes.bool, //是否有上一步
    hasNext: PropTypes.bool, //是否有下一步
    onLast: PropTypes.func, //上一步事件回调
    onNext: PropTypes.func, //下一步事件回调
    onFinish: PropTypes.func, //确认办理、取消办理完成回调
    onPrint: PropTypes.func, //打印报到单
}

const lstd = Form.create()(Lstd);
export default lstd;


// WEBPACK FOOTER //
// ./components/yxxc/steps/yntzyLstd.js